// extracted by mini-css-extract-plugin
export var container = "bB_f";
export var description = "bB_c";
export var formContainer = "bB_C";
export var neutral100 = "bB_dV";
export var neutral80 = "bB_dT";
export var textContainer = "bB_dD";
export var title = "bB_b";